import {
    ADD_WORKER_TO_COMPANY,
    REMOVE_WORKER_FROM_COMPANY,
    FETCH_WORKERS,
    LOCK_WORKER_BUDGET,
    FETCH_WORKER_PERMISSIONS,
    GRANT_PAYMENT_PERMISSION,
    REVOKE_PAYMENT_PERMISSION
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_WORKERS:
            return action.payload;
        case ADD_WORKER_TO_COMPANY:
            return state.concat(action.payload);
        case LOCK_WORKER_BUDGET:
            return state.map(card => card.id === action.payload.id ? { ...card, ...action.payload } : card);
        case REMOVE_WORKER_FROM_COMPANY:
            return state.filter(card => card.id !== action.payload.methodId);
        case FETCH_WORKER_PERMISSIONS:
            return state.map(card => card.userId === action.meta.id ? { ...card, permissions: action.payload } : card);
        case GRANT_PAYMENT_PERMISSION:
            return state.map(card => card.userId === action.meta.id ? { ...card, permissions: card.permissions.concat(action.payload) } : card);
        case REVOKE_PAYMENT_PERMISSION:
            return state.map(card => card.userId === action.meta.id ? { ...card, permissions: card.permissions.filter(p => p.id !== action.payload.permissionId) } : card);
        default:
            return state;
    }
};
